import UserMenu from './user-menu-container';

export default UserMenu;
